// C_OPTIONSInertialDampingDropDown.tsx
import { useState, ChangeEvent } from "react"
import "./index.css"
import { 
  // State initializers
  IModel, 
  // swmmReact data management
  OpenDefaultInpFileHeadless,
  OPTIONSInertialDampingDropDown,
  handleChange_OPTIONS,  
  // Display component
  DisplayHead 
  } from "./swmmreact"

// This is a demo control that allows a user to 
// modify the input to a swmm model.
const C_OPTIONSInertialDampingDropDown = () => {
  // State for contents of the .inp file.
  const [model, setModel] = useState<IModel | undefined>(undefined);

  return (
    <>
      {/* Open the default input file. */}
      <OpenDefaultInpFileHeadless setModel={setModel}
        fileNames={[process.env.PUBLIC_URL + '/Example1.inp']}/>

      {/* Create a dropdown control to modify the input. */}
      <div className='labelTop' >INERTIAL_DAMPING:</div>
      <OPTIONSInertialDampingDropDown 
        INERTIAL_DAMPING={model?.OPTIONS.INERTIAL_DAMPING}
        onChange={(e:ChangeEvent) => handleChange_OPTIONS(e, model, setModel)} />

      {/* Display the OPTIONS section for a live demonstration. */}
      <label className='labelTop' htmlFor='swmmJSON'>Model section in JSON format:</label>
      <DisplayHead model={model?.OPTIONS} />
    </>
  )
}

export { C_OPTIONSInertialDampingDropDown }